export default __webpack_public_path__ + "static/media/privilege-star.9bc998be.svg";